export const getPublicContentGroups = state => state.home.contentGroups;
export const getHashtagContentGroups = state => state.home.hashtagContentGroups;
export const getShowFavorite = state => state.home.showFavorite;
export const getIsLoadingHashtag = state => state.home.isLoadingHashtag;
export const getIsLoadingContentGroups = state => state.home.isLoadingContentGroups;
export const getShowHomeSearch = state => state.home.showHomeSearch;
export const getSearchRequest = state => state.home.searchRequest;
export const getFullTextSearchRequest = state => state.home.fullTextSearchRequest;
export const getFulltextSearch = state => state.home.fulltextSearch;
